// Espejo del enum del backend (src/features/cost-allocations/schemas.ts).
// Mantener sincronizado: si el backend agrega una categoría, falla el TS hasta
// que la mapeemos en CATEGORY_LABEL.
export const COST_CATEGORIES = [
  "feed",
  "pasture",
  "breeding",
  "veterinary",
  "labor",
  "other",
] as const;

export type CostCategory = (typeof COST_CATEGORIES)[number];

export const CATEGORY_LABEL: Record<CostCategory, string> = {
  feed: "Alimentación",
  pasture: "Pasturas",
  breeding: "Reproducción",
  veterinary: "Veterinaria",
  labor: "Mano de obra",
  other: "Otros",
};

export function categoryLabel(category: string): string {
  return (CATEGORY_LABEL as Record<string, string>)[category] ?? category;
}
